// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"styles_inputWrapper__h_IMw","captionContainer":"styles_captionContainer__LLK3N"};